/**
 * Captura erros 412 `CASH_REGISTER_REQUIRED` retornados pelo backend ao
 * tentar lançar conta a receber / aprovar orçamento sem caixa aberto.
 *
 * Para abrir o caixa na própria tela, use o hook `useCashRegisterPrompt`.
 */

export type CashRegisterRequiredResponse = {
  success: false;
  code: 'CASH_REGISTER_REQUIRED';
  error: string;
  unit_id?: string | null;
};

export function isCashRegisterRequiredError(err: unknown): err is { response: { status: number; data: CashRegisterRequiredResponse } } {
  const e = err as { response?: { status?: number; data?: { code?: string } } };
  return (
    e?.response?.status === 412 &&
    e?.response?.data?.code === 'CASH_REGISTER_REQUIRED'
  );
}

export function getCashRegisterErrorMessage(err: unknown): string {
  const e = err as { response?: { data?: { error?: string; message?: string } } };
  return (
    e?.response?.data?.error ||
    e?.response?.data?.message ||
    'Abra o caixa do dia antes de prosseguir.'
  );
}
